import { queryOptions, useQuery } from "@tanstack/react-query";
import {
  getMotionAmplificationAssignmentCustomers,
  getMotionAmplificationAssignmentFacilities,
  getMotionAmplificationAssignmentMachines,
} from "../clients/motion-amplification";

const assignmentKey = ["motion-amplification", "assignment"] as const;

export const motionAmplificationAssignmentCustomersQueryOptions = () =>
  queryOptions({
    queryKey: [...assignmentKey, "customers"],
    queryFn: async () =>
      (await getMotionAmplificationAssignmentCustomers()).options,
  });

export const motionAmplificationAssignmentFacilitiesQueryOptions = (
  customerId: string | null,
) =>
  queryOptions({
    queryKey: [...assignmentKey, "customers", customerId, "facilities"],
    queryFn: async () =>
      (await getMotionAmplificationAssignmentFacilities(customerId as string))
        .options,
    enabled: customerId !== null,
  });

export const motionAmplificationAssignmentMachinesQueryOptions = (
  facilityId: string | null,
) =>
  queryOptions({
    queryKey: [...assignmentKey, "facilities", facilityId, "machines"],
    queryFn: async () =>
      (await getMotionAmplificationAssignmentMachines(facilityId as string))
        .options,
    enabled: facilityId !== null,
  });

export function useMotionAmplificationAssignmentCustomersQuery() {
  return useQuery(motionAmplificationAssignmentCustomersQueryOptions());
}

export function useMotionAmplificationAssignmentFacilitiesQuery(
  customerId: string | null,
) {
  return useQuery(
    motionAmplificationAssignmentFacilitiesQueryOptions(customerId),
  );
}

export function useMotionAmplificationAssignmentMachinesQuery(
  facilityId: string | null,
) {
  return useQuery(
    motionAmplificationAssignmentMachinesQueryOptions(facilityId),
  );
}
